import React from 'react';
import UdulesiJogListaContent from './UdulesiJogListaContent';

const SzamlaListaBase = (props) => {
  let cardStyle = {
    padding: 20
  };

  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          {'Üdülésijog lista'}
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <UdulesiJogListaContent
              globals={props.route.globals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SzamlaListaBase;
